import { render, staticRenderFns } from "./GradePublishSettings.vue?vue&type=template&id=9ad822e4&scoped=true"
import script from "./GradePublishSettings.vue?vue&type=script&lang=js"
export * from "./GradePublishSettings.vue?vue&type=script&lang=js"
import style0 from "./GradePublishSettings.vue?vue&type=style&index=0&id=9ad822e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad822e4",
  null
  
)

export default component.exports